import { GoogleGeometry } from './GoogleGeometry';

export function ConnectionLength(connection, nodes, useMetricUnits = false) {
  // Make sure connection and nodes exist.
  if (connection == null) throw new Error('Connection is required');
  if (nodes == null) throw new Error('Nodes are required');
  // Find the first node.
  const node1 = nodes[connection.node_id_1];
  if (node1 == null) throw new Error('Failed to find node (node_id_1)');
  // Find the second node.
  const node2 = nodes[connection.node_id_2];
  if (node2 == null) throw new Error('Failed to find node (node_id_2)');
  // Build a list of LatLng objects from connection endpoints and breakpoints.
  const locations = [[node1.latitude, node1.longitude], ...(connection.breakpoints ?? []), [node2.latitude, node2.longitude]].map(
    (x) => new GoogleGeometry.maps.LatLng(...x)
  );
  // Calc the length between all of the points.
  const length = GoogleGeometry.maps.geometry.spherical.computeLength(locations) / (useMetricUnits ? 1 : 0.3048);
  // Return length.
  return length;
}
